/**
 * EmptyState — empty list placeholder with icon, text, and CTA.
 */
import { LucideIcon } from 'lucide-react';

interface EmptyStateProps {
  icon: LucideIcon;
  iconColor?: string;
  title: string;
  subtitle?: string;
  actionLabel?: string;
  onAction?: () => void;
}

export function EmptyState({ icon: Icon, iconColor = 'text-gray-400', title, subtitle, actionLabel, onAction }: EmptyStateProps): React.ReactElement {
  return (
    <div className="text-center py-12">
      <Icon className={`w-12 h-12 ${iconColor} mx-auto mb-3`} />
      <p className="text-gray-500 dark:text-gray-400 font-medium">{title}</p>
      {subtitle && <p className="text-sm text-gray-400 dark:text-gray-500 mt-1">{subtitle}</p>}
      {actionLabel && onAction && (
        <button onClick={onAction} className="btn btn-primary mt-4">
          {actionLabel}
        </button>
      )}
    </div>
  );
}
